/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import axios from "axios";
import { baseUrl } from "../../config/api";
import "./Portfolio.css";
import { SkeletonCategory, SkeletonProjectCard } from "../../Components";

const Portfolio = () => {
  // Portfolio data state
  const [allProjects, setAllProjects] = useState([]);
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filter by category
  const FilterCategory = (cat) => {
    if (cat.toLowerCase() === "all") {
      setProjects(allProjects);
    } else {
      const NewArrayCategory = allProjects.filter(
        (item) => item.category.toLowerCase() === cat.toLowerCase()
      );
      setProjects(NewArrayCategory);
    }
  };

  // --> Portfolio Fetch data
  useEffect(() => {
    const fetchPortfolioData = async () => {
      try {
        const res = await axios.get(`${baseUrl}/portfolio.json`);
        setAllProjects(res.data);
        setProjects(res.data);

        const Category = [
          "all",
          ...new Set(res.data.map((i) => i.category.toLowerCase())),
        ];

        setCategories(Category);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPortfolioData();
  }, []);

  useEffect(() => {
    const select = document.querySelector("[data-select]");
    const selectItems = document.querySelectorAll("[data-select-item]");
    const selectValue = document.querySelector("[data-selecct-value]");
    const filterItems = document.querySelectorAll("[data-filter-item]");

    const dataFilterBtns = document.querySelectorAll("[data-filter-btn]");

    const elementToggleFunc = (elem) => elem.classList.toggle("active");

    if (select) {
      select.addEventListener("click", () => elementToggleFunc(select));
    }

    dataFilterBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        filterItems.forEach((item) => {
          if (btn.innerText.toLowerCase() === "all") {
            item.classList.add("active");
          } else if (
            btn.innerText.toLowerCase() === item.dataset.category?.toLowerCase()
          ) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
        });
      });
    });

    // add event in all select items
    selectItems.forEach((item) => {
      item.addEventListener("click", function () {
        let selectedValue = this.innerText.toLowerCase();
        if (selectValue) selectValue.innerText = this.innerText;
        if (select) elementToggleFunc(select);

        filterItems.forEach((f) => {
          if (selectedValue === "all") {
            f.classList.add("active");
          } else if (selectedValue === f.dataset.category?.toLowerCase()) {
            f.classList.add("active");
          } else {
            f.classList.remove("active");
          }
        });
      });
    });
  }, []);

  return (
    <>
      {/* #PORTFOLIO */}
      <article className="portfolio" data-page="portfolio">
        <header>
          <h2 className="h2 article-title">Portfolio</h2>
        </header>
        <section className="projects">
          <ul className="filter-list">
            {loading ? (
              Array(4) // عدد مؤقت لأزرار الفلاتر
                .fill(null)
                .map((_, i) => <SkeletonCategory key={i} type="button" />)
            ) : categories.length ? (
              categories.map((i, idx) => {
                return (
                  <li className="filter-item" data-filter-item key={idx}>
                    <button onClick={() => FilterCategory(i)} data-filter-btn>
                      {i}
                    </button>
                  </li>
                );
              })
            ) : (
              <li>Not found category</li>
            )}
          </ul>
          <div className="filter-select-box">
            <button className="filter-select" data-select>
              <div className="select-value" data-selecct-value>
                Select category
              </div>
              <div className="select-icon">
                <ion-icon name="chevron-down"></ion-icon>
              </div>
            </button>
            <ul className="select-list">
              {loading ? (
                Array(4) // عدد مؤقت لعناصر select
                  .fill(null)
                  .map((_, i) => <SkeletonCategory key={i} type="select" />)
              ) : categories.length ? (
                categories.map((i, idx) => {
                  return (
                    <li className="select-item" data-select-item key={idx}>
                      <button
                        onClick={() => FilterCategory(i)}
                        data-select-item
                      >
                        {i}
                      </button>
                    </li>
                  );
                })
              ) : (
                <li>Not found category</li>
              )}
            </ul>
          </div>
          <ul className="project-list">
            {loading ? (
              Array(6) // عدد skeleton cards مؤقتة
                .fill(null)
                .map((_, i) => <SkeletonProjectCard key={i} />)
            ) : projects.length >= 0 ? (
              projects.map((i, idx) => {
                return (
                  <li
                    className="project-item  active"
                    data-filter-item
                    data-category={i.category}
                    key={idx}
                  >
                    <a href={i.link}>
                      <figure className="project-img">
                        <div className="project-item-icon-box">
                          <ion-icon name="eye-outline"></ion-icon>
                        </div>
                        <LazyLoadImage
                          src={i.img}
                          alt={i.title}
                          effect="blur"
                          placeholderSrc={i.title}
                        />
                      </figure>
                      <h3 className="project-title">{i.title}</h3>
                      <p className="project-category">{i.type}</p>
                    </a>
                  </li>
                );
              })
            ) : (
              <h1>Not found project</h1>
            )}
          </ul>
        </section>
      </article>
    </>
  );
};

export default Portfolio;
